import React from "react";

const BenefitsMobileIcon = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    width="12"
    height="20"
    viewBox="0 0 12 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.74359 0H1.53846C0.692308 0 0 0.692308 0 1.53846V18.4615C0 19.3077 0.692308 20 1.53846 20H9.74359C10.5897 20 11.2821 19.3077 11.2821 18.4615V1.53846C11.2821 0.692308 10.5897 0 9.74359 0ZM10.2564 18.4615C10.2564 18.7436 10.0256 18.9744 9.74359 18.9744H1.53846C1.25641 18.9744 1.02564 18.7436 1.02564 18.4615V17.4359H10.2564V18.4615ZM10.2564 16.4103H1.02564V3.58974H10.2564V16.4103ZM10.2564 2.5641H1.02564V1.53846C1.02564 1.25641 1.25641 1.02564 1.53846 1.02564H9.74359C10.0256 1.02564 10.2564 1.25641 10.2564 1.53846V2.5641Z"
      fill="#5B5A54"
    />
  </svg>
);

export default BenefitsMobileIcon;
